import AuthService from "./service/authService";
import { Routes, Route, useNavigate } from "react-router-dom";
import { SiteContainer, ProtectedRoute, Alert } from "@mikros/shared-ui";
import { MenuItem, ProtectedRouteProps } from "@mikros/library";
import { Home } from "./components/home/home";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { CustomerSearch } from "./components/customer/customerSearch";
import { Customer } from "./components/customer/customerDashboard";
import { AdminList } from "./components/admin/adminList";
import { ManageAdmin } from "./components/admin/manageAdmin";
import { Course } from "./components/courses/course";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { EditCourse } from "./components/courses/editCourse";
import { CreateCourse } from "./components/courses/createCourse";
import { Dialog } from "@progress/kendo-react-dialogs";

export default function AppRoutes() {
  const intl = useIntl();
  const { route } = useAuthenticator((context) => [context.route]);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [logOutSuccess, setlogOutSuccess] = useState<boolean>(false);

  const toggleLogOutDialog = () => {
    setlogOutSuccess(!logOutSuccess);
  };

  const logout = async () => {
    await AuthService.getInstance()
      .signOut()
      .then((response) => {
        // toast.success("Sign out successfully");
        toggleLogOutDialog();
        navigate("/login");
      });
  };

  
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    isAuthenticated: true,
    authenticationPath: "/login",
  };

  let siteMenu: MenuItem[] = [
    {
      // text: "Home",
      text: `${intl.formatMessage({
        id: "appRoutes.homeTab",
      })}`,
      icon: "fa-house",
      link: "/home",
      title: `${intl.formatMessage({
        id: "appRoutes.homeTab",
      })}`,
    },
    {
      // text: "Courses",
      text: `${intl.formatMessage({
        id: "appRoutes.courseTab",
      })}`,
      icon: "fa-book-open",
      link: "/courses",
      title: `${intl.formatMessage({
        id: "appRoutes.courseTabTitle",
      })}`,
    },
    { 
      text: `${intl.formatMessage({
        id: "appRoutes.customerTab",
      })}`,
     icon: "fa-users", 
     link: "/customer", 
     title: `${intl.formatMessage({
      id: "appRoutes.customerTab",
    })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.adminTab",
      })}`,
      icon: "fa-calendar-days",
      link: "/admin",
      title: `${intl.formatMessage({
        id: "appRoutes.adminTab",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.analyticsTab",
      })}`,
      icon: "fa-chart-simple",
      link: "/analytics",
      title:`${intl.formatMessage({
        id: "appRoutes.analyticsTab",
      })}`,
    },
    // {test:"Organization",icon:"fa-chart-simple",link:"/organization",title:"Organization Details"}
  ];

  useEffect(() => {
    if (route === "authenticated") {
      if (!isAuthenticated) {
        setIsAuthenticated(true);
        navigate("/home");
      }
    }
  }, [route]);

  return (
    <div>
      {/* <div className="overflow-y-hidden landingPage"> */}
      <div className="overflow-y-hidden">
        {logOutSuccess && (
          <Dialog className="confirmSuccessDialogue">
            <Alert
              description={intl.formatMessage({
                id: "appRoutes.logOut",
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"successShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgSuccess",
              })}
              backgroundColor={"mk-bright-green"}
              onClick={() => {
                toggleLogOutDialog();
              }}
            />
          </Dialog>
        )}

        {/* <IntlProvider locale={locale} defaultLocale={"en"} messages={messages}> */}
        <Routes>
          <Route
            path="/"
            element={<SiteContainer menu={siteMenu} logout={() => logout()} />}
          >
            <Route
              path="/home"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Home />}
                />
              }
            />
            <Route
              path="/courses"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Course />}
                />
              }
            />
            <Route
              path="/editCourse"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<EditCourse />}
                />
              }
            />
            <Route
              path="/createCourse"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<CreateCourse />}
                />
              }
            />
            <Route
              path="/customer"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<CustomerSearch />}
                />
              }
            />
            <Route
              path="/createCustomer/:id"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Customer />}
                />
              }
            />
            <Route
              path="/createCustomer/new"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Customer />}
                />
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<AdminList />}
                />
              }
            />
            <Route
              path="/manageAdmin/new"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<ManageAdmin />}
                />
              }
            />
            <Route
              path="/manageAdmin/:id"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<ManageAdmin />}
                />
              }
            />
          </Route>
        </Routes>
        {/* </IntlProvider> */}
      </div>
    </div>
  );
}
